( function( $ ) {
    var switched = false,
        padding = 30;//Project-specific settings
    var specialTable_id = 'PP2';
    var specialTable2_id = 'DP'; //Id of Development Properties table

    //delete the style and the colgroup
    $('table.ns-table-tab22').find('style').remove();
    $('table.ns-table-tab22').find('colgroup').remove();

    window.updateTables = function() {

        $('table[class^="ns-table"]').each(function(i, element) {
            var table_id = $(this).closest('[data-tableid]').attr('data-tableid');

            if ( ($(this)[0].clientWidth > $(this).parent()[0].clientWidth + padding) && !$(this).hasClass('switched') || table_id === specialTable2_id && !$(this).hasClass('switched')) {
                var realWidth = $(this)[0].clientWidth;

                $(this).addClass('responsive');

                if ( table_id === specialTable_id ) {
                    window.splitSpecialTable($(element));
                    $(this).addClass('specialTable');
                    $(this).closest('.table-wrapper').addClass('specialTable');

                    $(this).closest('.table-wrapper').prepend(
                        '<div class="top-scrollbar-wrapper scrollable-table"><div class="top-scrollbar" style="width:'+$('.scrollable table').width()+'px;"></div></div>'+
                        '<div class="top-scrollbar-wrapper pinned-table"><div class="top-scrollbar" style="width:'+$('.pinned table').width()+'px;"></div></div>'
                    );
                    $('td.line_bold[colspan="4"]').find("span").attr("style", "white-space: nowrap !important;");
                    $('td.line_bold[colspan="4"]').find("p").attr("style", "white-space: nowrap !important;");
                    $('td.line_bold[colspan="4"]').attr('colspan',1);

                } else if ( table_id === specialTable2_id ) {
                    window.splitSpecialTable2($(element));
                    $(this).addClass('specialTable2');
                    $(this).closest('.table-wrapper').addClass('specialTable2');

                    $(this).closest('.table-wrapper').prepend(
                        '<div class="top-scrollbar-wrapper scrollable-table"><div class="top-scrollbar" style="width:'+$('.scrollable table').width()+'px;"></div></div>'+
                        '<div class="top-scrollbar-wrapper pinned-table"><div class="top-scrollbar" style="width:'+$('.pinned table').width()+'px;"></div></div>'
                    );
                    $('td.line_bold[colspan="3"]').find("span").attr("style", "white-space: nowrap !important;");
                    $('td.line_bold[colspan="3"]').find("p").attr("style", "white-space: nowrap !important;");
                    //$('td.line_bold[colspan="3"]').attr('colspan',1);
                } else {
                    window.splitTable($(element));
                }

                $(this).addClass('switched');
                $(this).attr('realWidth', realWidth);
                return;
            } else if ($(this).hasClass('switched') && ($(this).attr('realWidth') <= $(this).parent()[0].clientWidth + padding) ) {
                window.unsplitTable($(element));
                $(this).removeClass('switched');
                $(this).removeClass('responsive');
            }
            $("body").addClass("table-loading-finished");
        });
    };

    $(document).ready(function () {
        var tables = $('.embed-container .ns-table > table');
        tables.each( function () {
            if(($(window).width() < 767)){
                $(this).parent().css('max-width', 'none');
            }
        });
        window.updateTables();

        //Scroll pinned div
        $('.top-scrollbar-wrapper.pinned-table').scroll(function(){
            $('.pinned').scrollLeft($(this).scrollLeft());
        });
        $('.pinned').scroll(function(){
            $('.top-scrollbar-wrapper.pinned-table').scrollLeft($(this).scrollLeft());
        });
        $('.scrollable.scrollable-header').scroll(function(){
            $('.scrollable.scrollable-content').scrollLeft($(this).scrollLeft());
        });
        $('.scrollable.scrollable-content').scroll(function(){
            $('.scrollable.scrollable-header').scrollLeft($(this).scrollLeft());
        });

        $('.scrollable.scrollable-content').scroll(function(){
            $('.pinned.pinned-content').scrollTop($(this).scrollTop());
        });
        $('.pinned.pinned-content').scroll(function(){
            $('.scrollable.scrollable-content').scrollTop($(this).scrollTop());
        });

        //Scroll scrollable div
        $('.top-scrollbar-wrapper.scrollable-table').scroll(function(){
            $('.scrollable').scrollLeft($(this).scrollLeft());
        });
        $('.scrollable').scroll(function(){
            $('.top-scrollbar-wrapper.scrollable-table').scrollLeft($(this).scrollLeft());
        });
    });
    $(window).on('redraw',function(){
        switched = false;
        window.updateTables();
    }); // An event to listen for

    $(window).on('resize', window.updateTables);

    window.splitTable = function (original) {
        original.addClass('switched');
        original.wrap("<div class='table-wrapper' />");
        var copy = original.clone();
        copy.find('td:not(:first-child), th:not(:first-child)').css('display', 'none');
        copy.removeClass('responsive');
        original.closest('.table-wrapper').append(copy);
        copy.wrap("<div class='pinned' />");
        original.wrap("<div class='scrollable' />");
        window.setCellHeights(original, copy);
    };

    window.splitSpecialTable = function (original) {
        original.addClass('switched');
        original.wrap("<div class='table-wrapper' />");

        var copy = original.clone();

        copy.find('td:not(:nth-child(-n+4)), th:not(:nth-child(-n+4))').css('display','none');
        copy.removeClass('responsive');
        original.closest('.table-wrapper').append(copy);
        copy.wrap("<div class='pinned' />");
        original.wrap("<div class='scrollable' />");

        //copy table a second time
        var pinnedCopy = $('.pinned').clone();
        var scrollableCopy = $('.scrollable').clone();
        $('.pinned').addClass('pinned-content');
        $('.scrollable').addClass('scrollable-content');
        pinnedCopy.insertBefore($('.pinned')).addClass('pinned-header');
        scrollableCopy.insertBefore($('.scrollable')).addClass('scrollable-header');

        setTimeout(function () {
            window.setCellHeights(original, copy);
        }, 500);
    };

    window.splitSpecialTable2 = function (original) {
        original.addClass('switched');

        original.wrap("<div class='table-wrapper' />");
        var copy = original.clone();
        copy.removeClass('responsive');
        original.removeClass('responsive');

        window.setCellHeights(original, copy);
        copy.find('td:not(:nth-child(-n+3)), th:not(:nth-child(-n+3)), td.line_bold[colspan="1"]').css('display', 'none');
        original.addClass('responsive');
        original.closest('.table-wrapper').append(copy);
        copy.wrap("<div class='pinned' />");
        original.wrap("<div class='scrollable' />");

        setTimeout(function () {
            window.setCellHeights(original, copy);
        }, 500);
    };

    window.unsplitTable = function (original) {
        original.closest(".table-wrapper").find(".pinned").remove();
        original.unwrap();
        original.unwrap();
    };

    window.setCellHeights = function (original, copy) {
        var tr = original.find('tr'),
            tr_copy = copy.find('tr'),
            heights = [];

        for (var i = 0; i < tr.length; i++) {
            var height = tr.eq(i).height();
            var c_height = tr_copy.eq(i).height();
            if (height > c_height) {
                tr_copy.eq(i).height(height);
            } else {
                tr.eq(i).height(c_height);
            }
        }

        let tableHover = '';

        if(document.querySelector('.ns-table-tab22')){
          tableHover = '.ns-table-tab22';
        } else if(document.querySelector('.ns-table-tab15')){
          tableHover = '.ns-table-tab15';
        }

        document.querySelectorAll('.ns-table table' + tableHover + ' tr').forEach(element => {
          element.addEventListener('mouseover', event => {

            document.querySelectorAll('.ns-table table' + tableHover + ' tr.ns-row--hover').forEach(el => {
              el.classList.remove('ns-row--hover');
            });

            document.querySelectorAll(tableHover + ' tr:nth-child(' + (element.rowIndex + 1) + ')').forEach(el => {
              el.classList.add('ns-row--hover');
            });
          });
        });
    }

})(jQuery);
